import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rowCheckbox", "openButton", "openTooltip"]
  static values = {
    frameId: { type: String, default: "product-costing-resell-calculator-frame" }
  }

  connect() {
    this.updateButton()
    this.boundOnSearchSubmit = this.reset.bind(this)
    this.boundOnSelectionUpdated = () => this.updateButton()
    document.addEventListener("search-form:submit", this.boundOnSearchSubmit)
    this.element.addEventListener("print-selection:updated", this.boundOnSelectionUpdated)
  }

  disconnect() {
    document.removeEventListener("search-form:submit", this.boundOnSearchSubmit)
    this.element.removeEventListener("print-selection:updated", this.boundOnSelectionUpdated)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  open() {
    const selected = this.rowCheckboxTargets.filter((cb) => cb.checked)
    if (selected.length !== 1) return

    const url = selected[0].dataset.resellCalculatorUrl
    if (!url) return

    Turbo.visit(url, { frame: this.frameIdValue })
  }

  reset() {
    this.rowCheckboxTargets.forEach((cb) => { cb.checked = false })
    this.updateButton()
  }

  updateButton() {
    if (!this.hasOpenButtonTarget) return

    const selectedCount = this.rowCheckboxTargets.filter((cb) => cb.checked).length
    const enabled = selectedCount === 1

    this.openButtonTarget.disabled = !enabled
    this.openButtonTarget.classList.toggle("btn-disabled", !enabled)

    if (this.hasOpenTooltipTarget) {
      if (enabled) {
        this.openTooltipTarget.dataset.tip = "Open resell calculator for selected item"
      } else if (selectedCount > 1) {
        this.openTooltipTarget.dataset.tip = "Select a single product costing"
      } else {
        this.openTooltipTarget.dataset.tip = "Select a product costing"
      }
    }
  }
}
